import React from 'react';
import {
  Hero,
  Statement,
  SelectedProjects,
  About,
  Skills,
  Expertise,
  Tools,
  Contact,
} from '../components/HomeSections';

const Home = () => (
  <div className="min-h-screen bg-[#050505] text-white overflow-hidden">
    <Hero />
    <Statement />
    <SelectedProjects />
    <About />
    <Skills />
    <Expertise />
    <Tools />
    <Contact />
  </div>
);

export default Home;
